import Highcharts from "highcharts";

type SeriesList = {
  name: string;
  values: {
    x: string;
    y: number;
  }[];
}[];

export const formatDateString = (dateStr: string): string => {
  const str = String(dateStr).trim();
  // yyyymmdd 形式を処理する (20260320)
  if (/^\d{8}$/.test(str)) {
    return `${str.substring(0, 4)}/${str.substring(4, 6)}/${str.substring(
      6,
      8
    )}`;
  }
  // yyyymm 形式を処理する (202603)
  if (/^\d{6}$/.test(str)) {
    return `${str.substring(0, 4)}/${str.substring(4, 6)}`;
  }
  // yyyy-mm-dd形式で処理(2026-03-20)
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    return str.replace(/-/g, "/");
  }
  // すでに yyyy/mm/dd 形式になっているため、直接返します
  if (/^\d{4}\/\d{2}\/\d{2}$/.test(str)) {
    return str;
  }
  // 他の形式はそのまま返されます
  return str;
};

export const formatThousandthsDigits = (
  value: number | undefined,
  seriesList: SeriesList
) => {
  if (!value) return "";
  const hasDecimal = seriesList.some(series =>
    series.values.some(point => point.y !== undefined && point.y % 1 !== 0)
  );
  return Highcharts.numberFormat(value, hasDecimal ? 3 : 0, ".", ",");
};
